import { Box, Container, Typography, Grid, Button, Divider } from '@mui/material'
import { IconButton, Tooltip } from '@mui/material'
import SvgIcon from '@mui/material/SvgIcon'
import { useTheme } from '@mui/material/styles'
import { useState } from 'react'
import { MAIN } from '../../../config/routes'
import team1 from '../../../assets/images/team/1.png'
import team2 from '../../../assets/images/team/2.png'
import team3 from '../../../assets/images/team/3.png'
import team4 from '../../../assets/images/team/4.png'
import team5 from '../../../assets/images/team/5.png'
import team6 from '../../../assets/images/team/6.png'
import team7 from '../../../assets/images/team/7.png'
import team8 from '../../../assets/images/team/8.png'
import team9 from '../../../assets/images/team/9.png'
import team10 from '../../../assets/images/team/10.png'
import team11 from '../../../assets/images/team/11.png'
import team12 from '../../../assets/images/team/12.png'
import team13 from '../../../assets/images/team/13.png'
import headerBgImage from '../../../assets/images/arbol-ec/fondos/021.jpg'
import { useNavigate } from 'react-router-dom'
import RgIcon from '../../../assets/icons/RG.png'
import { ReactComponent as OrcidIcon } from '../../../assets/icons/orcid.svg'
import SchoolIcon from '@mui/icons-material/School'
import EmailIcon from '@mui/icons-material/Email'
import LinkedInIcon from '@mui/icons-material/LinkedIn'

import './css/TeamComponent.css'

const teamData = [
  {
    name: 'Andrés Roosevelt Armijos Montaño, Mg. Sc.',
    position: 'Director',
    facultad: 'Facultad Agropecuaria y de Recursos Naturales Renovables',
    carrera: 'Ingeniería Forestal',
    description:
      'Magíster en Gestión Forestal con énfasis en Ciencia de Datos, Ingeniero Forestal (UNL) y docente-investigador en la Universidad Nacional de Loja, especializado en el análisis y gestión de información técnica, así como en la evaluación de la calidad de la madera como base para la toma de decisiones estratégicas en la gestión forestal.',
    image: team10,
    email: 'ararmijosm@unl.edu.ec',
    links: [
      'https://www.researchgate.net/profile/Andres-Armijos-Montano',
      'https://orcid.org/0000-0001-8742-1382',
      'https://www.linkedin.com/in/andresrarmijos/',
    ],
    experiencia: `Ingeniero Forestal con máster en Gestión Forestal basada en Ciencia de Datos. Cuenta con experiencia en docencia universitaria, investigación aplicada y gestión de la información. Ha colaborado en proyectos locales y publicaciones científicas sobre anatomía de la madera, dendrocronología y gestión forestal. Actualmente dirige el proyecto de arbolado urbano de la ciudad de Loja, enfocándose en el manejo, conservación y gestión del arbolado urbano en la ciudad de Loja.`,
  },
  {
    name: 'Darwin Alexander Pucha Cofrep, Ph.D.',
    position: 'Investigador (PI)',
    facultad: 'Facultad Agropecuaria y de Recursos Naturales Renovables',
    carrera: 'Ingeniería Forestal',
    description:
      'Ph.D. en Recursos Naturales (FAU-Alemania), Ingeniero Forestal (UNL) y docente-investigador en la Universidad Nacional de Loja. Director de Laboratorio de Dendrocronología y Anatomía de Maderas Tropicales',
    image: team2,
    email: 'darwin.pucha@unl.edu.ec',
    links: [
      'https://www.researchgate.net/profile/Darwin-Pucha-Cofrep',
      'https://orcid.org/0000-0003-3212-1184',
      'https://www.linkedin.com/in/darwin-alexander-pucha-cofrep-0b3977212/',
    ],
    experiencia: `Experto en dinámica de crecimiento, anatomía de maderas y servicios ecosistémicos del arbolado urbano. Ha dirigido investigaciones pioneras en inventarios forestales, aplicaciones web y metodologías para la valoración del arbolado urbano en Loja, fomentando la participación ciudadana y la gestión sostenible. Autor de múltiples publicaciones indexadas, dirige actualmente la Maestría en Biodiversidad y Cambio Climático. Su trabajo impulsa soluciones innovadoras para conservar y optimizar el arbolado como infraestructura verde esencial ante los retos de sostenibilidad y cambio climático urbano.`,
  },
  {
    name: 'Ing. Johnny Fabián González Guamán',
    position: 'Techlead',
    facultad:
      'Facultad de la Energía, las Industrias y los Recursos Naturales no Renovables',
    carrera: 'Ingeniería en Sistemas',
    description:
      'Ingeniero en Sistemas (UNL), técnico-especialista de la Aplicación web ÁrbolEc, desarrollador de aplicaciones informáticas y software a medida.',
    image: team8,
    email: 'jfgonzalezg@unl.edu.ec',
    links: [
      'https://www.researchgate.net/profile/Johnny-Gonzalez',
      'https://orcid.org/0000-0002-4844-6453',
      'https://www.linkedin.com/in/johgg10/',
    ],
    experiencia: `Desarrollador de software con formación en Ingeniería en Sistemas por la Universidad Nacional de Loja (UNL). Cuenta con experiencia en el diseño, desarrollo y mantenimiento de aplicaciones web y móviles, con énfasis en soluciones para la gestión ambiental y forestal. Ha participado en proyectos interdisciplinarios como ÁrbolEc, contribuyendo con herramientas tecnológicas para el monitoreo forestal, valoración económica y diagnóstico de riesgos en el arbolado urbano. Su trabajo se enfoca en la integración de datos geoespaciales, sistemas de información y análisis computacional al servicio de la sostenibilidad.`,
  },
  {
    name: 'Deicy Carolina Lozano Sivisaca, Ph.D.',
    position: 'Investigadora',
    facultad: 'Facultad Agropecuaria y de Recursos Naturales Renovables',
    carrera: 'Ingeniería Forestal',
    description:
      'Ph.D. en Ciencia Forestal, Magíster en Socioeconomía Ambiental del Centro Agronómico Tropical de Investigación y Enseñanza (CATIE), Ingeniera Forestal (UNL) y docente-investigadora en la Universidad Nacional de Loja.',
    image: team6,
    email: 'deicy.lozano@unl.edu.ec',
    links: [
      'https://www.researchgate.net/profile/Deicy-Lozano',
      'https://orcid.org/0000-0002-3294-9312',
      'https://www.linkedin.com/in/deicy-lozano-sivisaca-7109a180/',
    ],
    experiencia: `Ingeniera Forestal graduada de la Universidad Nacional de Loja (UNL) en 2009, tiene maestría en Socioeconomía Ambiental del Centro Agronómico Tropical de Investigación y Enseñanza (CATIE) en 2013, Turrialba, Costa Rica; Doctorado en Ciencias Forestales del Programa de Posgrado en Ciencia Forestal en la Universidade Estadual Paulista "Júlio de Mesquita Filho" (UNESP) en 2020, São Paulo, Brasil; ha sido docente invitada en la Universidad Técnica Particular de Loja (UTPL) en la carrera de Gestión Ambiental, en la UNESP-Brasil en Ingeniería Forestal y docente en la maestría en silvicultura, manejo y conservación de recursos forestales en la Universidad Estatal Amazónica, docente-investigadora en la UNL, Facultad Agropecuaria y de Recursos Naturales, entre 2010-2011 y 2014-actual. Ha sido parte del Comité Editorial de la Revista Científica Bosques Latitud Cero de la Universidad Nacional de Loja. Tiene experiencia en la conservación de recursos naturales, específicamente en estudios de biodiversidad, dinámica forestal, socioeconomía ambiental, economía ambiental y bioestadística en bosques tropicales. Ha realizado varias publicaciones como artículos científicos, resúmenes publicados en libros de congresos, ponencias y participación en congresos nacionales e internacionales.`,
  },
  {
    name: 'Nohemi del Carmen Jumbo Benítez, Ph.D.',
    position: 'Investigadora',
    facultad: 'Facultad Agropecuaria y de Recursos Naturales Renovables',
    carrera: 'Ingeniería Forestal',
    description:
      'Ph.D. en Agricultura Sustentable y Mg.Sc. en Tecnología de Alimentos, Ingeniera en Industrias Agropecuarias (UNL) y docente-investigadora en la Universidad Nacional de Loja.',
    image: team5,
    email: 'nohemi.jumbo@unl.edu.ec',
    links: [
      'https://www.researchgate.net/profile/Nohemi-Jumbo-Benitez',
      'https://orcid.org/0000-0001-7921-122X',
      'https://www.linkedin.com/in/nohem%C3%AD-jumbo-benitez-932393161/',
    ],
    experiencia: `Ingeniera en Industrias Agropecuarias de profesión y nacida en la ciudad de Loja, Ecuador. Estudios universitarios realizados en la Universidad Técnica Particular de Loja (UTPL), Mg.Sc. en Tecnología de Alimentos, y Ph.D. en Agricultura Sustentable en la Universidad Nacional Agraria la Molina Lima-Perú. Con un Diplomado en Inocuidad de Alimentos. Docente e investigadora en la UNL. Revisora para revistas científicas locales e internacionales. Investigaciones realizadas en el área de sustentabilidad, alimentos, química de la madera. Directora del DI-FARNR-2025: "Servicios ecosistémicos de los SAF de café para la sostenibilidad, mitigación y adaptación al cambio climático en Loja 2025-2027".`,
  },
  {
    name: 'Alexandra del Cisne Jiménez Torres, Mg. Sc.',
    position: 'Investigadora',
    facultad: 'Facultad Agropecuaria y de Recursos Naturales Renovables',
    carrera: 'Ingeniería Forestal',
    description:
      'Mg. Sc. en Práctica de la Conservación de la Biodiversidad, Ingeniera Forestal (UNL) y docente-investigadora en la Universidad Nacional de Loja.',
    image: team1,
    email: 'alexandra.jimenez@unl.edu.ec',
    links: [
      'https://www.researchgate.net/profile/Alexandra-Jimenez-Torres',
      'https://orcid.org/0000-0002-3877-1084',
    ],
    experiencia: `Ingeniera Forestal nacida en Loja, Ecuador, con formación académica en la Universidad Nacional de Loja. Poseo una Maestría en Práctica de la Conservación de la Biodiversidad y un Diplomado en Equidad e Inclusión por CATIE, Costa Rica, además de un Diplomado en Manejo y Conservación de Recursos Naturales de la Universidad Autónoma de Yucatán, México. Actualmente, soy candidata a Ph.D. en el Programa de Agricultura y Medio Ambiente para el Desarrollo en la Universidad de Santiago de Compostela, España. Mi experiencia combina la gestión sostenible de la biodiversidad con un enfoque integral en conservación, equidad e inclusión, respaldada por una sólida formación internacional y multidisciplinaria.`,
  },
  {
    name: 'Paulina Vanesa Fernández Guarnizo, Mg. Sc.',
    position: 'Investigadora',
    facultad: 'Facultad Agropecuaria y de Recursos Naturales Renovables',
    carrera: 'Ingeniería Agronómica',
    description:
      'Mg. Sc. en Agroforestería y Trópico Húmedo, Ingeniera Agrónoma y Docente-Investigadora de la Universidad Nacional de Loja.',
    image: team11,
    email: 'paulina.fernadez@unl.edu.ec',
    links: [
      'https://orcid.org/0000-0003-3308-4469',
      'https://www.linkedin.com/in/paulina-fern%C3%A1ndez-guarnizo-b22a8225/',
    ],
    experiencia: ``,
  },
  {
    name: 'Wilman Patricio Chamba Zaragocín, Mg. Sc.',
    position: 'Investigador',
    facultad:
      'Facultad de la Energía, las Industrias y los Recursos Naturales no Renovables',
    carrera: 'Computación',
    description:
      'Mg. Sc. en Software Libre, Ingeniero en Informática, experto en Gerencia de Proyectos, Arquitectura de Software y Desarrollo Senior, docente-investigador en la Universidad Nacional de Loja.',
    image: team7,
    email: 'wpchamba@unl.edu.ec',
    links: [
      'https://www.researchgate.net/profile/Wilman-Chamba-Zaragocin',
      'https://orcid.org/0000-0002-1733-1485',
      'https://www.linkedin.com/in/wchamba/',
    ],
    experiencia: `Consultor independiente especializado en desarrollo de software empresarial con tecnologías libres desde 2009, para entidades públicas (Gobiernos Autónomos Municipales, Asamblea Nacional) y privadas (Loxageek Cia Ltda). Experto en Gerencia de Proyectos, Arquitectura de Software y Desarrollo Senior.
Docente universitario e investigador con experiencia en el Instituto Tecnológico "Los Andes" y, principalmente, en la Universidad Nacional de Loja (UNL), donde ha impartido cátedra en pregrado (Carrera Ingeniería de Sistemas / Computación) y posgrado (Maestría en Ingeniería de Software).
Actualmente ejerce como docente investigador en la Carrera de Computación (UNL), combinándolo con proyectos de consultoría freelance en sus tiempos libres.`,
  },
  {
    name: 'Oscar Miguel Cumbicus Pineda, Ph.D.',
    position: 'Investigador',
    facultad:
      'Facultad de la Energía, las Industrias y los Recursos Naturales no Renovables',
    carrera: 'Computación',
    description:
      'Ph.D. en Inteligencia Artificial y profesor asociado en la Universidad Nacional de Loja. Especialista en ciencia de datos, IA y sistemas inteligentes, centra su investigación en aplicaciones educativas y sociales.',
    image: team12,
    email: 'oscar.cumbicus@unl.edu.ec',
    links: [
      'https://www.researchgate.net/profile/Oscar-M-Cumbicus-Pineda',
      'https://orcid.org/0000-0001-5483-0913',
      'https://www.linkedin.com/in/oscar-m-cumbicus-pineda-47095443/',
    ],
    experiencia: `Oscar M. Cumbicus‑Pineda es PhD en Inteligencia Artificial, Ingeniero en Sistemas y Magíster en Ingeniería Computacional y Sistemas Inteligentes. Profesor asociado en el Área de Energía de la Universidad Nacional de Loja, imparte clases de Machine Learning, Data Mining, inteligencia artificial y sistemas expertos. Es profesor certificado en Ciencia de Datos por Cisco. Ha trabajado como ingeniero en el Consejo Nacional Electoral y técnico en el Banco de Loja. Sus líneas de investigación incluyen procesamiento de lenguaje natural, minería de datos, computación en la nube y sistemas inteligentes, destacándose por su enfoque en aplicaciones educativas y sociales de la IA.`,
  },
  {
    name: 'Cristian Patricio Retete López, Mg. Sc.',
    position: 'Técnico/Docente',
    facultad: 'Magíster Facultad Agropecuaria y de Recursos Naturales Renovables',
    carrera: 'Ingeniería Forestal',
    description:
      'Mg. Sc. en Gestión de Proyectos, Ingeniero Forestal (UNL) y técnico-docente en el Laboratorio de Anatomía de Maderas Tropicales de la Universidad Nacional de Loja.',
    image: team3,
    email: 'cristian.retete@unl.edu.ec',
    links: [
      'https://orcid.org/0009-0002-7262-7147',
      'https://www.researchgate.net/profile/Cristian-Retete',
      'https://www.linkedin.com/in/cristian-patricio-retete-lopez-462b9228a',
    ],
    experiencia: `Ingeniero Forestal graduado de la Universidad Nacional de Loja, con formación de posgrado en Gestión de Proyectos. Especialista en anatomía de la madera y manejo forestal, con experiencia en investigación aplicada a los recursos naturales. Actualmente me desempeño como Técnico Docente en el Laboratorio de Anatomía de Maderas Tropicales de la Facultad Agropecuaria y de Recursos Naturales Renovables de la UNL. He participado en proyectos de investigación que me han permitido generar información científica y técnica, así como fortalecer mis capacidades en la gestión sostenible de los bosques y la aplicación de tecnologías para el estudio de la madera.`,
  },
  {
    name: 'Ing. Jefferson Iván Quezada Armijos',
    position: 'Técnico/Docente',
    facultad: 'Facultad Agropecuaria y de Recursos Naturales Renovables',
    carrera: 'Ingeniería Forestal',
    description:
      'Ingeniero Forestal (UNL) y técnico-docente del Laboratorio de Dendrocronología de la Universidad Nacional de Loja.',
    image: team9,
    email: 'jefferson.quezada@unl.edu.ec',
    links: [
      'https://orcid.org/0009-0006-7929-4997',
      'https://www.researchgate.net/profile/Jefferson-Quezada',
      'https://www.linkedin.com/in/jefferson-quezada-246341309',
    ],
    experiencia: `Ingeniero Forestal de profesión y vocación, nacido en la ciudad de Loja. Técnico docente del Laboratorio de Dendrocronología de la Universidad Nacional de Loja, donde he desarrollado experiencia en el análisis de la dinámica de crecimiento de diversas especies forestales, aplicando técnicas como la dendrocronología y el estudio de anillos de crecimiento. Cuento con habilidades en el uso de software de programación y herramientas tecnológicas aplicadas a la investigación forestal.`,
  },
  {
    name: 'Fernando Alexis González Soto, Mg. Sc.',
    position: 'Técnico/Docente',
    facultad: 'Centros de Investigaciones Territoriales',
    carrera: null,
    description:
      'Mg. Sc. en Gestión Ambiental, Ingeniero Ambiental con experiencia en análisis de incendios forestales, consultoría territorial y docencia universitaria.',
    image: team4,
    email: 'fernando.gonzalez@unl.edu.ec',
    links: [
      'https://www.researchgate.net/profile/Fernando-Gonzalez-119',
      'https://orcid.org/0000-0002-2171-6556',
      'https://www.linkedin.com/in/fernando-alexis-gonzalez-soto-a1a2b5272/',
    ],
    experiencia: `Consultor independiente en temas territoriales y ambientales, con participación en diversos proyectos de alcance local para entidades públicas y académicas. A los 25 años ejerció como docente universitario en la Universidad Agraria del Ecuador (Guayaquil). Actualmente se desempeña como técnico-docente en el Centro de Investigaciones Territoriales de la Universidad Nacional de Loja (UNL), donde combina la docencia con actividades de investigación aplicada. Revisor científico del *International Journal of Wildland Fire* y autor en proceso de publicación de artículos científicos sobre incendios forestales y gestión ambiental.`,
  },
  {
    name: 'Nikolay Arturo Aguirre Mendoza, Ph.D.',
    position: 'Investigador',
    facultad: 'Rector de la Universidad Nacional de Loja (UNL)',
    carrera: 'Rector',
    description:
      'Ph.D. en Ciencias Forestales obtenido en la Universidad Técnica de Múnich (Alemania). Ingeniero Forestal por la Universidad Nacional de Loja. Rector de la Universidad Nacional de Loja.',
    image: team13,
    email: 'rector@unl.edu.ec',
    links: [],
    experiencia: `Investigador experto en Ciencias Forestales y Rector de la Universidad Nacional de Loja (UNL)`,
  },
]

const TeamMemberCard = ({ member, isDirector = false }) => {
  const theme = useTheme()
  const [expandedExperience, setExpandedExperience] = useState(false)

  if (isDirector) {
    // Diseño mejorado para directores sin estilo card
    return (
      <Box sx={{ py: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* Header con imagen y info básica */}
        <Grid container spacing={3} alignItems="center">
          {/* Imagen optimizada */}
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                mb: { xs: 2, sm: 0 },
              }}>
              <Box
                component="img"
                src={member.image}
                alt={member.name}
                sx={{
                  width: '100%',
                  maxWidth: 220,
                  height: 220,
                  objectFit: 'cover',
                  borderRadius: '50%',
                  border: `4px solid ${theme.palette.primary.main}`,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                }}
              />

              {/* Badge de posición centrado en la parte inferior */}
              <Box
                sx={{
                  position: 'absolute',
                  bottom: -10,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: '#2c3e50',
                  color: 'white',
                  px: 2.5,
                  py: 1,
                  borderRadius: 3,
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                  minWidth: '140px',
                }}>
                {member.position}
              </Box>
            </Box>
          </Grid>

          {/* Información principal */}
          <Grid item xs={12} sm={8}>
            <Typography
              variant="h5"
              fontWeight={700}
              gutterBottom
              sx={{
                color: theme.palette.text.primary,
                lineHeight: 1.2,
              }}>
              {member.name}
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
                mb: 2,
                lineHeight: 1.5,
                textAlign: 'justify',
              }}>
              {member.description}
            </Typography>

            {/* Información académica en chips */}
            <Box sx={{ mb: 2 }}>
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  background: theme.palette.background.gray_light,
                  color: theme.palette.secondary.dark,
                  px: 2,
                  py: 0.5,
                  borderRadius: 2,
                  fontSize: '0.85rem',
                  fontWeight: 500,
                  mb: 1,
                  mr: 1,
                }}>
                <Box mr={1}>
                  <SchoolIcon sx={{ fontSize: '12px' }} />
                </Box>{' '}
                {member.carrera}
              </Box>
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  background: theme.palette.background.gray_light,
                  color: theme.palette.info.dark,
                  px: 2,
                  py: 0.5,
                  borderRadius: 2,
                  fontSize: '0.85rem',
                  fontWeight: 500,
                  mb: 1,
                }}>
                <Box mr={1}>
                  <EmailIcon sx={{ fontSize: '12px' }} />
                </Box>
                {member.email}
              </Box>
            </Box>

            {/* Enlaces profesionales estilizados */}
            <Box display="flex" gap={1} mb={2}>
              {member.links
                ?.filter(link => link.includes('orcid') || link.includes('researchgate'))
                .map((link, i) => {
                  const isOrcid = link.includes('orcid')
                  // const isRg = link.includes('researchgate')

                  return (
                    <Tooltip key={i} title={isOrcid ? 'ORCID' : 'ResearchGate'} arrow>
                      <IconButton
                        component="a"
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ transition: 'all 0.2s ease' }}>
                        {isOrcid ? (
                          <SvgIcon
                            component={OrcidIcon}
                            inheritViewBox
                            sx={{ fontSize: 25 }}
                          />
                        ) : (
                          <Box
                            component="img"
                            src={RgIcon}
                            alt="ResearchGate"
                            sx={{ width: 42, height: 28 }}
                          />
                        )}
                      </IconButton>
                    </Tooltip>
                  )
                })}

              {/* Enlaces sociales */}
              {member.links
                ?.filter(link =>
                  ['linkedin', 'x.com', 'instagram', 'facebook'].some(s =>
                    link.includes(s),
                  ),
                )
                .map((link, i) => (
                  <Tooltip key={i} title="Red Social" arrow>
                    <IconButton
                      component="a"
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        transition: 'all 0.2s ease',
                        color: '#0077B5',
                        '&:hover': { color: '#0077B5' },
                      }}>
                      <LinkedInIcon />
                    </IconButton>
                  </Tooltip>
                ))}
            </Box>
          </Grid>
        </Grid>

        {/* Empuja la sección de experiencia al fondo para alinear el botón entre columnas */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Sección expandible de experiencia */}
        <Box sx={{ mt: 3, ml: { xs: 0, sm: 1, md: '3vw', lg: 0 } }}>
          <Button
            variant="outlined"
            onClick={() => setExpandedExperience(!expandedExperience)}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              py: 1,
              borderColor: theme.palette.primary.main,
              color: theme.palette.primary.main,
              '&:hover': {
                background: theme.palette.primary.main,
                color: 'white',
              },
              transition: 'all 0.2s ease',
            }}
            endIcon={
              expandedExperience ? (
                <i className="bi bi-chevron-up" />
              ) : (
                <i className="bi bi-chevron-down" />
              )
            }>
            {expandedExperience ? 'Ocultar experiencia' : 'Leer experiencia'}
          </Button>

          <Box
            sx={{
              overflow: 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              maxHeight: expandedExperience ? '1000px' : '0px',
            }}>
            <Box
              sx={{
                mt: 2,
                p: 3,
                background: '#f8f9fa',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
              }}>
              <Typography
                variant="body2"
                sx={{
                  lineHeight: 1.6,
                  textAlign: 'justify',
                  color: theme.palette.text.secondary,
                }}>
                {member.experiencia}
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  display: 'block',
                  mt: 2,
                  fontStyle: 'italic',
                  color: theme.palette.text.disabled,
                }}>
                <strong>Facultad:</strong> {member.facultad}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    )
  }

  // Diseño uniforme para otros miembros con el mismo estilo
  return (
    <Box className="member" sx={{ textAlign: 'center' }}>
      {/* Imagen circular con badge al estilo de los directores */}
      <Box sx={{ position: 'relative', display: 'inline-block', mb: 3 }}>
        <Box
          component="img"
          src={member.image}
          alt={member.name}
          sx={{
            width: 200,
            height: 200,
            objectFit: 'cover',
            borderRadius: '50%',
            border: `4px solid ${theme.palette.primary.main}`,
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          }}
        />

        {/* Badge de posición centrado en la parte inferior */}
        <Box
          sx={{
            position: 'absolute',
            bottom: -10,
            left: '50%',
            transform: 'translateX(-50%)',
            background: theme.palette.primary.main,
            color: 'white',
            px: 3,
            py: 1,
            borderRadius: 3,
            fontSize: '0.9rem',
            fontWeight: 600,
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            textAlign: 'center',
            minWidth: '140px',
          }}>
          {member.position}
        </Box>

        {/* Íconos sociales en hover */}
        <Box
          className="social"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            justifyContent: 'center',
            gap: 1,
            opacity: 0,
            transition: 'opacity 0.3s',
            '&:hover': {
              opacity: 1,
            },
            '.member:hover &': {
              opacity: 1,
            },
          }}>
          {member.links
            ?.filter(
              link =>
                link.includes('x.com') ||
                link.includes('linkedin') ||
                link.includes('instagram') ||
                link.includes('facebook'),
            )
            .map((link, i) => {
              return (
                <a
                  key={i}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#fff',
                    fontSize: 18,
                    background: 'rgba(0,0,0,0.7)',
                    borderRadius: '50%',
                    width: 36,
                    height: 36,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textDecoration: 'none',
                  }}>
                  <i
                    className={
                      link.includes('linkedin')
                        ? 'bi bi-linkedin'
                        : link.includes('instagram')
                          ? 'bi bi-instagram'
                          : link.includes('facebook')
                            ? 'bi bi-facebook'
                            : link.includes('x.com')
                              ? 'bi bi-twitter-x'
                              : ''
                    }
                  />
                </a>
              )
            })}
        </Box>
      </Box>

      {/* Información del miembro */}
      <Box>
        <Typography
          variant="body2"
          sx={{ fontSize: '0.85rem', fontWeight: 600, mb: 0.5 }}>
          {member.carrera} 🎓 UNL
        </Typography>
        <Typography
          variant="h6"
          fontWeight={600}
          gutterBottom
          sx={{
            color: theme.palette.text.primary,
            lineHeight: 1.2,
          }}>
          {member.name}
        </Typography>

        <Typography variant="body2" sx={{ textAlign: 'justify', mb: 2, px: 1 }}>
          {member.description}
        </Typography>
        <Typography variant="body2" sx={{ fontSize: '0.85rem', fontWeight: 500, mb: 2 }}>
          {member.email}
        </Typography>
        {/* Enlaces profesionales */}
        <Box display="flex" justifyContent="center" gap={1}>
          {member.links
            ?.filter(link => link.includes('orcid') || link.includes('researchgate'))
            .map((link, i) => {
              const isOrcid = link.includes('orcid')
              // const isRg = link.includes('researchgate')

              return (
                <Tooltip key={i} title={isOrcid ? 'ORCID' : 'ResearchGate'} arrow>
                  <IconButton
                    component="a"
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ transition: 'all 0.2s ease' }}>
                    {isOrcid ? (
                      <SvgIcon
                        component={OrcidIcon}
                        inheritViewBox
                        sx={{ fontSize: 25 }}
                      />
                    ) : (
                      <Box
                        component="img"
                        src={RgIcon}
                        alt="ResearchGate"
                        sx={{ width: 42, height: 28 }}
                      />
                    )}
                  </IconButton>
                </Tooltip>
              )
            })}
        </Box>
      </Box>
    </Box>
  )
}

const TeamComponent = () => {
  const theme = useTheme()
  const navigate = useNavigate()

  const handleOnClick = () => navigate(MAIN)

  return (
    <Box sx={{ fontFamily: theme.typography.fontFamily }}>
      <Box
        sx={{
          backgroundImage: `url(${headerBgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'top',
          position: 'relative',
          color: theme.palette.text.ivory,
          mt: '5.8vh',
          height: '40vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}>
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundColor: `${theme.palette.text.darkBlue}AA`,
          }}
        />
        <Box sx={{ position: 'relative', zIndex: 1, px: { xs: 4, md: 5 } }}>
          <Typography
            sx={{
              maxWidth: 800,
              color: theme.palette.text.white,
              fontWeight: 500,
              textShadow: '0 0 1px rgba(255, 255, 255, 0.8)',
              fontSize: '1.2rem',
            }}>
            Nuestro equipo multidisciplinario está conformado por profesionales
            comprometidos con el desarrollo sostenible, la innovación tecnológica y el
            cuidado del entorno urbano.
          </Typography>
        </Box>
      </Box>

      <Box pb={4} pt={{ xs: 1, md: 2 }} px={{ xs: 5, md: 8, lg: 10 }}>
        <Box component="nav" mt={3}>
          <Box
            component="ol"
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              listStyle: 'none',
              justifyContent: 'end',
              p: 0,
              m: 0,
              fontSize: 16,
              fontWeight: 400,
            }}>
            <Box component="li">
              <Button
                onClick={handleOnClick}
                variant="text"
                sx={theme => ({
                  fontSize: 16,
                  fontWeight: 600,
                  color: theme.palette.text.mustard,
                  p: 0,
                  px: 2,
                  minWidth: 0,
                  '&:hover': {
                    color: theme.palette.text.primary,
                  },
                })}>
                Inicio
              </Button>
            </Box>
            <Box
              component="li"
              sx={{
                pl: 1,
                position: 'relative',
                fontWeight: 500,
                color: theme.palette.text.secondary,
              }}>
              <Box component="span" sx={{ pr: 1 }}>
                /
              </Box>{' '}
              Equipo
            </Box>
          </Box>
        </Box>

        <Divider />
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            borderLeft: `4px solid ${theme.palette.secondary.main}`,
            pl: 4,
          }}>
          <Typography
            variant="h2"
            gutterBottom
            fontWeight={600}
            sx={{ color: theme.palette.text.forestGreen, my: 2 }}>
            Equipo multidisciplinario
          </Typography>
        </Box>

        {/* Secciones lado a lado */}
        <Grid container spacing={4} sx={{ my: 4 }}>
          {/* Dirección del proyecto */}
          <Grid item xs={12} lg={6} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                borderLeft: `4px solid ${theme.palette.secondary.main}`,
                pl: 2,
                mb: 3,
              }}>
              <Typography
                variant="h4"
                gutterBottom
                fontWeight={600}
                sx={{ color: theme.palette.text.forestGreen, my: 0 }}>
                Dirección del proyecto
              </Typography>
            </Box>
            <Box px={{ xs: 1, sm: 2 }} sx={{ flexGrow: 1 }}>
              <TeamMemberCard member={teamData[0]} isDirector={true} />
            </Box>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                borderLeft: `4px solid ${theme.palette.secondary.main}`,
                pl: 2,
                mb: 3,
              }}>
              <Typography
                variant="h4"
                gutterBottom
                fontWeight={600}
                sx={{ color: theme.palette.text.forestGreen, my: 0 }}>
                Coordinador del proyecto (PI)
              </Typography>
            </Box>
            <Box px={{ xs: 1, sm: 2 }} sx={{ flexGrow: 1 }}>
              <TeamMemberCard member={teamData[1]} isDirector={true} />
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            borderLeft: `4px solid ${theme.palette.secondary.main}`,
            pl: 2,
            mb: 3,
          }}>
          <Typography
            variant="h4"
            gutterBottom
            fontWeight={600}
            sx={{ color: theme.palette.text.forestGreen, my: 0 }}>
            Coordinación de Innovación Tecnológica
          </Typography>
        </Box>

        <Box component="section" id="team" className="team section" py={6}>
          <Container>
            <Grid container spacing={5}>
              {teamData
                .filter(
                  member =>
                    member.email.includes('wpchamba@unl.edu.ec') ||
                    member.email.includes('jfgonzalezg@unl.edu.ec') ||
                    member.email.includes('oscar.cumbicus@unl.edu.ec'),
                )
                .map((member, idx) => (
                  <Grid
                    key={idx}
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    data-aos="fade-up"
                    data-aos-delay={100 + idx * 100}>
                    <TeamMemberCard member={member} isDirector={false} />
                  </Grid>
                ))}
            </Grid>
          </Container>
        </Box>

        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            borderLeft: `4px solid ${theme.palette.secondary.main}`,
            pl: 2,
            mb: 3,
          }}>
          <Typography
            variant="h4"
            gutterBottom
            fontWeight={600}
            sx={{ color: theme.palette.text.forestGreen, my: 0 }}>
            Coordinación de Investigación Científica
          </Typography>
        </Box>

        <Box component="section" id="team" className="team section" py={6}>
          <Container>
            <Grid container spacing={5}>
              {teamData
                .filter(
                  member =>
                    !member.name.includes('Andrés Roosevelt Armijos') &&
                    !member.name.includes('Darwin Alexander Pucha') &&
                    !member.name.includes('Johnny Fabián González') &&
                    !member.name.includes('Jefferson Iván Quezada') &&
                    !member.name.includes('Wilman Patricio Chamba') &&
                    !member.name.includes('Fernando Alexis González') &&
                    !member.name.includes('Cristian Patricio Retete') &&
                    !member.name.includes('Oscar Miguel Cumbicus'),
                )
                .map((member, idx) => (
                  <Grid
                    key={idx}
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    data-aos="fade-up"
                    data-aos-delay={100 + idx * 100}>
                    <TeamMemberCard member={member} isDirector={false} />
                  </Grid>
                ))}
            </Grid>
          </Container>
        </Box>

        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            borderLeft: `4px solid ${theme.palette.secondary.main}`,
            pl: 2,
            mb: 3,
          }}>
          <Typography
            variant="h4"
            gutterBottom
            fontWeight={600}
            sx={{ color: theme.palette.text.forestGreen, my: 0 }}>
            Coordinación Técnica Especializada
          </Typography>
        </Box>

        <Box component="section" id="team" className="team section" py={6}>
          <Container>
            <Grid container spacing={5}>
              {teamData
                .filter(
                  member =>
                    member.name.includes('Jefferson Iván Quezada') ||
                    member.name.includes('Cristian Patricio Retete') ||
                    member.name.includes('Fernando Alexis González'),
                )
                .map((member, idx) => (
                  <Grid
                    key={idx}
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    data-aos="fade-up"
                    data-aos-delay={100 + idx * 100}>
                    <TeamMemberCard member={member} isDirector={false} />
                  </Grid>
                ))}
            </Grid>
          </Container>
        </Box>
      </Box>
    </Box>
  )
}

export default TeamComponent
